"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => ({
    radioBtnWrapper: {
        display: 'flex',
        flexDirection: 'column',
        '&[data-is-inline=true]': {
            flexDirection: 'row'
        }
    },
    radioBtn: {
        padding: 7
    }
});
//# sourceMappingURL=radio.style.js.map